import { ENROLLED, GUEST } from 'consts';

export const getOwnerType = (payer) =>
  String(payer?.ownerType ?? '')
    .trim()
    .toLowerCase();

export const isEnrolledOwner = (payer) => getOwnerType(payer) === ENROLLED;

export const isGuestOwner = (payer) => getOwnerType(payer) === GUEST;

export const isEnrolledPalRoute = (payer, fspConfig) =>
  isEnrolledOwner(payer) &&
  fspConfig?.ifpPalOnOff === 'on' &&
  fspConfig?.enrolledUserOffOn === 'on' &&
  !!(fspConfig?.guestUrl && String(fspConfig.guestUrl).trim());
